import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Industries = () => {
  const industries = [
    {
      title: 'Oilfield',
      description: 'Specialized manufacturing solutions for upstream oil and gas operations including BOP systems, frac equipment, and custom fabrication.',
      link: '/industries/oilfield',
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&q=80',
    },
    {
      title: 'Midstream & Process Industries',
      description: 'Precision manufacturing for processing facilities, pipeline systems, and storage infrastructure with ASME code compliance.',
      link: '/industries/midstream',
      image: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=600&q=80',
    },
    {
      title: 'Data Centers',
      description: 'Custom enclosures, server racks, and precision support structures for critical data infrastructure and equipment.',
      link: '/industries/data-centers',
      image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd65d4?w=600&q=80',
    },
    {
      title: 'Infrastructure & Construction',
      description: 'Heavy structural fabrication, architectural metalwork, and custom solutions for construction and infrastructure projects.',
      link: '/industries/infrastructure',
      image: 'https://images.unsplash.com/photo-1581092921461-eab62e97a780?w=600&q=80',
    },
  ];

  return (
    <div className="min-h-screen pt-20" data-testid="industries-page">
      <section className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-testid="industries-hero">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1581092921461-eab62e97a780?w=1920&q=80"
            alt="Industries We Serve"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-gray-900/85"></div>
        </div>
        <div className="max-w-7xl mx-auto relative z-10">
          <h1 className="text-4xl sm:text-5xl font-bold text-white heading-font mb-6" data-testid="industries-heading">
            Industries We Serve
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            Trusted manufacturing partner across diverse sectors, delivering precision and reliability where it matters most.
          </p>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" data-testid="industries-grid">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            {industries.map((industry, index) => (
              <Link
                key={index}
                to={industry.link}
                className="group bg-white rounded-2xl overflow-hidden shadow-md card-hover border border-gray-100"
                data-testid={`industry-card-${index}`}
              >
                <div className="aspect-[16/9] overflow-hidden bg-gray-100">
                  <img
                    src={industry.image}
                    alt={industry.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 heading-font mb-4">{industry.title}</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">{industry.description}</p>
                  <div className="flex items-center text-blue-700 font-semibold group-hover:text-blue-800">
                    Learn More
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50" data-testid="industries-cta">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-900 heading-font mb-6">Don't See Your Industry?</h2>
          <p className="text-gray-600 mb-8">
            We serve many additional industries with custom manufacturing solutions. Contact us to discuss your specific needs.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-4 bg-blue-700 text-white rounded-lg hover:bg-blue-800 font-semibold transition-all shadow-md"
            data-testid="industries-contact-button"
          >
            Contact Us
            <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Industries;